export default __webpack_public_path__ + "static/media/campo.dda0ed95.jpg";